<template>
  <div style="height: 100%; width: 100%" class="deptree">
    <a-input-search
      v-model="searchStr"
      placeholder="请输入机构名称"
      style="width: 100%"
      @search="onSearch"
    >
    </a-input-search>
    <!-- selectedKeys是选中项key的集合，expandedKeys是展开项key的集合 -->
    <a-tree
      style="height: 99%; width: 100%; margin-top: 20px"
      v-if="treeData.length"
      v-model="checkedKeys"
      :treeData="treeData"
      :selectedKeys="selectedKeys"
      @expand="onExpand"
      :defaultExpandAll="defaultExpandAll"
      :expandedKeys="expandedKeys"
      :defaultExpandParent="autoExpandParent"
      :replaceFields="replaceFields"
      @select="onSelect"
    >
      <template slot="title" slot-scope="{ name }">
        <span
          v-html="
            name.replace(
              new RegExp(searchValue, 'g'),
              '<span style=color:#f50>' + searchValue + '</span>'
            )
          "
        ></span>
      </template>
    </a-tree>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expandedKeys: [],
      backupsExpandedKeys: [],
      checkedKeys: [],
      autoExpandParent: true,
      defaultExpandAll: true,
      selectedKeys: [],
      treeData: [],
      searchValue: "",
      searchStr: "",
      replaceFields: {
        title: "name",
      },
      initExpandedKeys: [],
    };
  },
  mounted() {
    this.axios.get("web/emp/getDeptTree").then((res) => {
      this.treeData.push(res.data);
      if (res.data.key) {
        this.initExpandedKeys.push(res.data.key);
      }
      this.expandedKeys = [""];
      this.expandedKeys.push(...this.initExpandedKeys);
      if (res.data && res.data.key) {
        this.$emit("query", res.data.key, res.data.name);
      }
    });
  },
  methods: {
    onSearch() {
      this.searchValue = this.searchStr;
      if (this.searchValue === "") {
        this.expandedKeys = [];
        this.expandedKeys.push(...this.initExpandedKeys);
        return;
      } else {
        this.expandedKeys = [];
        this.backupsExpandedKeys = [];
        const candidateKeysList = this.getkeyList(
          this.searchValue,
          this.treeData,
          []
        );
        candidateKeysList.forEach((item) => {
          const key = this.getParentKey(item, this.treeData);
          // eslint-disable-next-line no-shadow
          if (key && !this.backupsExpandedKeys.some((item) => item === key))
            this.backupsExpandedKeys.push(key);
        });
        const { length } = this.backupsExpandedKeys;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < length; i++) {
          this.getAllParentKey(this.backupsExpandedKeys[i], this.treeData);
        }
        this.expandedKeys = this.backupsExpandedKeys.slice();
        this.expandedKeys.push("");
      }
    },
    // 获取节点中含有value的所有key集合
    getkeyList(value, tree, keyList) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.name.indexOf(value) > -1) {
          keyList.push(node.key);
        }
        if (node.children) {
          this.getkeyList(value, node.children, keyList);
        }
      }
      return keyList;
    },
    // 该递归主要用于获取key的父亲节点的key值
    getParentKey(key, tree) {
      let parentKey;
      let temp;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some((item) => item.key === key)) {
            parentKey = node.key;
            // eslint-disable-next-line no-cond-assign
          } else if ((temp = this.getParentKey(key, node.children))) {
            parentKey = temp;
          }
        }
      }
      return parentKey;
    },
    // 获取该节点的所有祖先节点
    getAllParentKey(key, tree, keys) {
      let parentKey;
      if (!keys) keys = [key];
      if (key) {
        parentKey = this.getParentKey(key, tree);
        if (parentKey) {
          if (!this.backupsExpandedKeys.some((item) => item === parentKey)) {
            this.backupsExpandedKeys.push(parentKey);
          }
          keys.unshift(parentKey);
          let arr = this.getAllParentKey(parentKey, tree, keys);
          if (arr) return arr;
        } else {
          return keys;
        }
      }
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, e) {
      this.selectedKeys = selectedKeys;
      let deptCode = selectedKeys[selectedKeys.length - 1];
      let deptCodes = this.getAllParentKey(deptCode, this.treeData);
      let deptName =
        e.selectedNodes[e.selectedNodes.length - 1].data.props.name;
      this.$emit("query", deptCode, deptName, deptCodes);
    },
  },
};
</script>

<style scoped>
.deptree >>> .ant-tree {
  max-height: calc(100% - 45px);
  max-width: 100%;
  overflow: auto;
}
</style>
